<template>
  <div class="home">
    <img src="../assets/logo.png" class="title" />
    <span class="name" v-model="numberOfRegistered" @click="updateNumberOfRegistered">当前注册人数：{{numberOfRegistered}}人</span>
    <el-container>
      <el-container>
        <el-aside width="10%">
          <el-menu
            :default-active="isChoose"
            class="el-menu-vertical-demo"
            >
            <el-menu-item index="1" @click="useTime" :disabled="isTop">
              <i class="el-icon-timer"></i>
              <span slot="title">使用时长</span>
            </el-menu-item>
            <el-menu-item index="2" @click="location" :disabled="isTop">
              <i class="el-icon-location-outline"></i>
              <span slot="title">探头分布</span>
            </el-menu-item>
            <el-menu-item index="3" @click="search" :disabled="isTop">
              <i class="el-icon-setting"></i>
              <span slot="title">路径选择</span>
            </el-menu-item>
            <!-- <el-menu-item index="4" @click="releaseVersion" :disabled="isTop">
              <i class="el-icon-goods"></i>
              <span slot="title">版本发布</span>
            </el-menu-item> -->
            <!-- <el-menu-item index="5" @click="errorcount" :disabled="isTop">
              <i class="el-icon-eleme"></i>
              <span slot="title">错误代码</span>
            </el-menu-item> -->
            <el-menu-item index="6" @click="addTempUser" :disabled="isTop">
              <i class="el-icon-user"></i>
              <span slot="title">临时账号</span>
            </el-menu-item>
            <el-menu-item index="7" @click="releaseNews" :disabled="isTop">
              <i class="el-icon-video-play"></i>
              <span slot="title">新闻发布</span>
            </el-menu-item>
            <el-menu-item index="8" @click="storkUserCount" :disabled="isTop">
              <i class="el-icon-place"></i>
              <span slot="title">月注册用户</span>
            </el-menu-item>
            <el-menu-item index="9" @click="dataDownload" :disabled="isTop">
              <i class="el-icon-folder"></i>
              <span slot="title">数据下载</span>
            </el-menu-item>
            <el-menu-item index="10" @click="manageHospital" :disabled="isTop">
              <i class="el-icon-office-building"></i>
              <span slot="title">医院管理</span>
            </el-menu-item>
            <el-menu-item index="11" @click="plaqueCount" :disabled="isTop">
              <i class="el-icon-set-up"></i>
              <span slot="title">斑筛统计</span>
            </el-menu-item>
            <el-menu-item index="12" @click="probeRent" :disabled="isTop">
              <i class="el-icon-date"></i>
              <span slot="title">探头租赁</span>
            </el-menu-item>
            <el-menu-item index="13" @click="uploadFiles" :disabled="isTop">
              <i class="el-icon-upload"></i>
              <span slot="title">文件上传</span>
            </el-menu-item>
            <el-menu-item index="14" @click="areaDisplay" :disabled="isTop">
              <i class="el-icon-place"></i>
              <span slot="title">斑筛区域</span>
            </el-menu-item>
            <el-menu-item index="15" @click="hospitalDataExport" :disabled="isTop">
              <i class="el-icon-place"></i>
              <span slot="title">数据导出</span>
            </el-menu-item>
            <el-menu-item index="16" @click="logout">
              <i class="el-icon-switch-button"></i>
              <span slot="title">退出登录</span>
            </el-menu-item>
          </el-menu>
        </el-aside>
        <el-main class="main">
          <router-view @getSSID="getMsg" @getRoute="getRoute" @getLocation="getUsername" />
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import usetime from '../components/UseTime';
import location from '../components/Location';
import route from '../components/Route';
import search from '../components/Search';
import errorcount from '../components/ErrorCount';
import addTempUser from './tempuser/AddTempUser';
import releaseVersion from './version/ReleaseVersion';
import StorkUserCount from '../components//StorkUserCount';
import Global from "./Global";
import AreaDisplay from '../components/area_display/AreaDisplay'

export default {
  mounted() {
    let currentusername = this.$store.getters.getUser.name
    let that = this;
    if (currentusername === 'Stork_123') {
      this.$router.push({'name': 'location', params:{username: ''}});
      this.axios(
        {
          method: 'GET',
          url: Global.accountUrl + '/storkCollectData/getNumberOfRegistered'
        }
      ).then(function(response){
        if(response.data.code == 200) {
          that.numberOfRegistered = response.data.data;
        }
        else {
          that.$message.error('请求数据失败');
        }
      });
    } else if (currentusername === 'fusu123' ) {
      this.$router.push({'name': 'newsManage'});
      this.isTop = true
      this.isChoose = '7'
    }else if (currentusername === 'zhanglin' || currentusername === 'paul123') {
      this.$router.push({'name': 'datadownload'});
      this.isTop = true
      this.isChoose = '9'
    }
  },
  data() {
    return {
      isUsetime: true,
      isLocation: false,
      isRoute: false,
      ssid: '',
      username: '',
      numberOfRegistered: 0,
      isTop: false,
      isChoose: '2'
    }
  },
  methods: {
    useTime() {
      this.$router.push({'name': 'usetime'})
    },
    location() {
      this.$router.push({'name': 'location', params:{username: ''}})
    },
    locationByParam() {
      this.$router.push({'name': 'location', params:{username: this.username}})
    },
    route() {
      this.$router.push({'name': 'route', params:{ssid: this.ssid}})
    },
    search() {
      this.$router.push({'name': 'search'})
    },
    errorcount() {
      this.$router.push({'name': 'errorcount'})
    },
    releaseVersion() {
      this.$router.push({'name': 'releaseVersion'})
    },
    dataDownload () {
      this.$router.push({'name': 'datadownload'})
    },
    manageHospital () {
      this.$router.push({'name': 'createHospital'})
    },
    plaqueCount () {
      this.$router.push({'name': 'plaqueCount'})
    },
    probeRent () {
      this.$router.push({'name': 'ProbeRent'})
    },
    uploadFiles () {
      this.$router.push({'name': 'UploadFiles'})
    },
    areaDisplay () {
      this.$router.push({'name': 'areaDisplay'})
    },
    getMsg(ssid) {
      this.ssid = ssid;
      this.route();
    },
    logout() {
      this.$router.push({'name': 'logout'})
    },
    getRoute(ssid) {
      this.ssid = ssid;
      this.route();
    },
    getUsername(username) {
      this.username = username;
      this.locationByParam();
    },
    updateNumberOfRegistered() {
      let that = this;
      this.axios(
        {
          method: 'GET',
          url: Global.accountUrl + '/storkCollectData/getNumberOfRegistered'
        }
      ).then(function(response){
        if(response.data.code == 200) {
          that.numberOfRegistered = response.data.data;
        }
        else {
          that.$message.error('请求数据失败');
        }
      });
    },
    addTempUser() {
      this.$router.push({'name': 'addTempUser'});
    },
    releaseNews() {
      this.$router.push({'name': 'newsAdd'});
    },
    storkUserCount() {
      this.$router.push({'name': 'StorkUserCount'});
    },
    hospitalDataExport () {
      this.$router.push({'name': 'hospitalDataExport'})
    }
  }
}
</script>

<style scoped>
  .home {
    height: 100%;
  }
  .el-container {
    height: 100%;
  }

  .el-menu {
    height: 100%;
  }

  .el-header {
    position: relative;
    background-color: #909399;
    color: #409EFF;
    line-height: 60px;
    border-radius: 10px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    text-align: right;
    font-size: 28px;
  }

  .el-aside {
    color: #333;
    height: 100%;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  }

  .main {
    height: 100%;
    background-color: #FFFFFF;
    padding: 5px 0px 5px 0px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  }

  .title {
    position: fixed;
    height: 10%;
    right: 1%;
    top: 2%;
    z-index: 15;
  }

  .name {
    font-size: 1rem;
    position: fixed;
    bottom: 1%;
    left: 0.5%;
    z-index: 15;
    color: rgba(0, 150, 255);
  }

</style>



// WEBPACK FOOTER //
// src/components/Home.vue